import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Home from "../Home/Home";
import Loader from "../Loader/Loader";
import EditSpecialPass from "./EditSpecialPass";
import authContext from "../../../../AuthContext/authContext";

const base_url = process.env.REACT_APP_BASE_URL;

const EditSpecialPassWrapper = () => {
  const activeEditVisitorId = useSelector(
    (state) => state.appData.activeEditVisitorId
  );
  const ctx = useContext(authContext);
  const token = ctx.token;
  const [initialData, setInitialData] = useState({});
  const [domLoaded, setDomLoaded] = useState(false);

  useEffect(() => {
    getVisitorData();
  }, []);

  const getVisitorData = () => {
    let reqObj = {
      method: "GET",
      url: `${base_url}/visitor/get-special-visitor/${activeEditVisitorId}`,
      headers: {
        "Content-Type": "application/javascript",
        Authorization: `Bearer ${token}`,
      },
    };

    axios(reqObj)
      .then((res) => {
        // console.log("Edit special pass data", res);
        setInitialData({ ...res.data.data });
        setDomLoaded(true);
      })
      .catch((err) => {
        // console.log(err);
      });
  };

  return (
    <>
      <Home
        propComponent={
          domLoaded ? (
            <EditSpecialPass
              initialData={initialData}
              onSuccess={() => getVisitorData()}
            />
          ) : (
            <>
              <Loader centerLoader={"centerLoader"} />
            </>
          )
        }
      />
    </>
  );
};

export default EditSpecialPassWrapper;
